import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { App, type URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Subject } from 'rxjs';

const APP_HOST = 'app.budgets.money';
const RETURN_HOST = 'return.budgets.money';

@Injectable({ providedIn: 'root' })
export class NativeLinkService {
  private readonly router = inject(Router);

  private readonly hostedPlaidCompleted = new Subject<void>();
  private initialized = false;

  readonly hostedPlaidCompleted$ = this.hostedPlaidCompleted.asObservable();

  initializeNativeBridge(): void {
    if (this.initialized || !Capacitor.isNativePlatform()) return;
    this.initialized = true;

    void App.addListener('appUrlOpen', event => this.handleUrl(event));
    void App.getLaunchUrl().then(event => {
      if (event) this.handleUrl(event);
    });
  }

  private handleUrl(event: URLOpenListenerEvent): void {
    // Some Android WebViews parse custom schemes as opaque paths with no hostname.
    if (event.url.split(/[?#]/, 1)[0] === 'budgets://plaid/complete') {
      this.hostedPlaidCompleted.next();
      return;
    }

    const url = new URL(event.url);
    if (url.protocol === 'https:' && url.hostname === RETURN_HOST) {
      if (url.pathname === '/onboarding/billing-complete')
        void this.router.navigateByUrl('/getting-started?billingReturn=completed');
      if (url.pathname === '/onboarding/billing-cancelled')
        void this.router.navigateByUrl('/getting-started?billingReturn=cancelled');
      return;
    }

    // Hosted Link resumes its own app-to-app OAuth session after this
    // universal link foregrounds the app.
    if (url.protocol === 'https:' && url.hostname === APP_HOST && url.searchParams.has('oauth_state_id')) return;

    if (url.protocol === 'https:' && url.hostname === APP_HOST)
      void this.router.navigateByUrl(`${url.pathname}${url.search}${url.hash}`);
  }
}
